import { Profile } from "../../../models/Profile";

export const hasEditAreasAccess = (userProfile: Profile): boolean => {
    return (userProfile != null && userProfile.areaTab) || hasEditSites(userProfile);
}

export const hasViewUsersAccess = (userProfile: Profile): boolean => {
    return (userProfile != null && userProfile.viewUsers) || hasEditSites(userProfile);
}

export const hasEditUsersAccess = (userProfile: Profile): boolean => {
    return (userProfile != null && userProfile.userTab);
}

export const hasViewAreasAccess = (userProfile: Profile): boolean => {
    return (userProfile != null && userProfile.viewAreas) || hasEditSites(userProfile);
}

export const hasEditProjectsAccess = (userProfile: Profile): boolean => {
    return (userProfile != null && userProfile.createEditProject);
}

export const nonEditableProfile = (userProfile: Profile): boolean => {
    if (!userProfile) {
        return false
    }
    return userProfile.name === "Admin" || userProfile.name === "User" || userProfile.name === "Read Only";
}

export const hasEditSites = (userProfile: Profile): boolean => {
    return userProfile != null && userProfile.editSites;
}
